import { useRecoilState } from "recoil";
import { mergeUnique } from "../../../lib/array";
import { createNotification } from "../../../lib/notification";
import { updateTicket } from "../../../repositories/ticketRepo";
import ticketListState from "../../../state/ticketListState";
import ticketSelectState, { TICKET_SELECT_KEYS } from "../../../state/ticketSelectState";
import Button from "../../atoms/button/Button";
import useAuthContext from "../../context/AuthContext";

const TicketListFunctions = () => {

  const [selectState, setSelectState] = useRecoilState(ticketSelectState)
  const [ticketList, setTicketList]= useRecoilState(ticketListState);
  const {currentShop, currentAgent} = useAuthContext()
  const onClickAssignMe = () => {
    const promises = []
    const newTickets = []
    const ids = selectState[TICKET_SELECT_KEYS.assign]
    if (!ids?.length) return
    ids?.forEach((id) => {
      const newTicket = {
        id: id,
        agent: currentAgent?.id
      }
      newTickets.push(newTicket)
      const promise = updateTicket(currentShop?.id, newTicket)
      promises.push(promise)
    })
    const errors = []
    const successes = []
    Promise.all(promises.map((p) => {
      return new Promise((resolve, reject) => {
        p.then((value) => {
          resolve([value, null]);
        }).catch((err) => {
          resolve([null, err])
        });
      });
    })).then((resList) => {
      resList.forEach((res, index) => {
        if (res[1] == null) {
          const id = ids[index]
          successes.push(id)
          setTicketList((ticketList) => {
            const _ticket = ticketList.find((__ticket) => __ticket.id == id)
            const newTicket = newTickets[index]
            return mergeUnique(ticketList, [{
              ..._ticket,
              agent: newTicket['agent']
            }])
          })
        } else {
          errors.push(newTickets[index])
        }
      })

      setSelectState((selectState) => {
        const ids = selectState[TICKET_SELECT_KEYS.assign]
        return {
          [TICKET_SELECT_KEYS.assign]: ids.filter((_id) => !successes.includes(_id))
        }
      })

      if (!errors?.length) {
        createNotification('success', '選択したお問い合せの担当者に設定しました。');
      } else {
        createNotification('error', `下記のお問合せの担当者への設定を失敗しました。${errors}`)
      }
    })
  }

  return (<div className="mb-5 flex justify-end">
  <Button onClick={onClickAssignMe}>担当する</Button>
</div>)
}

export default TicketListFunctions;